import React from 'react';
import { useLanguage } from '../context/LanguageContext';

const Features = () => {
  const { t } = useLanguage();

  return (
    <section id="sidekicks" className="relative bg-fog bg-mint-wash overflow-hidden">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8 py-24">
        <div className="max-w-2xl">
          <p className="text-mint text-sm font-bold uppercase tracking-[0.2em]">{t.sidekicks.kicker}</p>
          <h2 className="mt-4 font-display font-bold text-4xl lg:text-5xl text-ink leading-tight text-balance">
            {t.sidekicks.title}{' '}
            <span className="text-mint">{t.sidekicks.titleAccent}</span>
          </h2>
          <p className="mt-5 text-lg text-mute leading-relaxed">{t.sidekicks.body}</p>
        </div>

        <div className="mt-14 grid sm:grid-cols-2 lg:grid-cols-4 gap-8 lg:gap-6">
          {t.sidekicks.items.map((item) => (
            <article key={item.num} className="group">
              <div className="relative aspect-[3/4] overflow-hidden bg-mist">
                <img
                  src={item.image}
                  alt={item.title}
                  className="w-full h-full object-cover object-top transition-transform duration-700 group-hover:scale-105"
                  width={600}
                  height={800}
                />
                <div
                  className="absolute inset-x-0 bottom-0 h-1/3 bg-gradient-to-t from-ink/70 to-transparent"
                  aria-hidden
                />
                <span className="absolute bottom-3 left-3 font-display font-bold text-mint-soft text-sm tracking-wide">
                  {item.num}
                </span>
              </div>
              <h3 className="mt-4 font-display font-bold text-xl text-ink">{item.title}</h3>
              <p className="mt-2 font-medium text-mint text-sm">{item.prompt}</p>
              <p className="mt-2 text-mute leading-relaxed text-sm">{item.description}</p>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Features;
